export default __webpack_public_path__ + "static/media/ISEO CLASS-4 EXAM PATTERN 2025.053af512.pdf";